import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';

export const BtnContainer = styled(Box)`
  width: 100%;
  cursor: pointer;
  ${({ theme }) => css`
    background-color: ${theme.colors.mediumGrey};
    transition: background-color 0.25s ease-in-out;
    &:hover {
      background-color: ${theme.colors.primary};
    }
  `};
`;

export const GiftBtnContainer = styled(Box)`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;

  ${({ theme }) => css`
    transition: ${theme.transitions.create('color')};
    font-weight: ${theme.fontWeights.bold};
    font-size: ${theme.fontSizes.p2};
    padding: ${theme.spacing(2, 4)};
  `}

  svg {
    ${({ theme }) => css`
      margin: ${theme.spacing(0, 0.5)};
    `}
  }
`;
